export class Certification {
  id: any;
  certificationContent: any;
  extension = "";
  error = "";
  name = "";
  constructor(id: any) {
    this.id = id;
  }
}